import React from 'react';
import {
  ripleyBank,
  frecuentQuestions,
  legalRPGOBank,
  forgottenPassword,
  ripleyReturnPeriods,
  whatsAppLineContact,
} from '../config/paths';

export const CONTENT_TITLE = '¿En qué podemos ayudarte?';

export const DELIVERY_CREDIT_NOTE_CHECK =
  'Debes revisar si cuentas con el suficiente cupo para que podamos realizar la devolución de tu dinero.';

export const INSERT_MAIN_DATA =
  'Debes ingresar tu Rut y N° de orden de compra:';

export const INSERT_DNI_DATA = 'Debes ingresar tu Rut y N° de documento:';

export const TICKET_MESSAGE_INNER_FORMS =
  'Uno de nuestros agentes revisará tu solicitud lo antes posible. Estamos trabajando para darte la mejor solución.';

export const TITLE_ERROR = 'No hemos podido enviar tu solicitud';

export const SUBTITLE_ERROR =
  'Lo sentimos, estamos presentando algunas dificultades, vuelve a intentarlo dentro de un momento';

export const GIFT_CARD_NOT_FOUND =
  'Número de Gift Card no válido, intenta nuevamente.';

export const INVALID_CAPTCHA =
  'Verificación de captcha no válido, marca la casilla nuevamente.';

export const CHANGE_ADDRESS =
  'El cambio de dirección solo es posible dentro de la misma comuna.';

export const CHANGE_DATE = 'El despacho se realizará a cualquier hora del día';

export const COMPLETE_FORM = 'Completa el formulario con tus datos:';

export const RUT_NOT_FOUND =
  'Lo sentimos, el Rut ingresado no pertenece a ningún cliente.';

export const INVALID_RUT = 'Número de Rut no válido, intenta nuevamente.';

export const HELPER_COMPLETE = 'Ayúdanos ingresando los datos a continuación';

export const BETTER_ATTENTION =
  'Para una mejor atención recuerda completar todos los campos';

export const INVALID_NUMBER_REQUEST =
  'Para una mejor atención, debes incluir un N° de requerimiento en tu solicitud.';

export const CHOOSE_OPTION = 'Elige una opción:';

export const FULFILLED_REVERSE_OPTION =
  '¿Se cumplió el plazo informado y no tienes la reversa?';
export const REVERSE_PAYMENT_METHOD_OPTION =
  '¿Medio de Pago Tarjeta Ripley o Check?';

export const FULFILLED_REVERSE =
  'Gracias, si necesitas ayuda vuelve a contactarnos.';

export const CHANGE_PRODUCTS_EXTRA_OPTIONS =
  'Selecciona el inconveniente con tu producto:';

export const SELECT_PROBLEM_GIFTCARD =
  'Selecciona el inconveniente que tienes con tu Gift Card:';

export const INFO_SERIE_IDENTITY_CARD =
  'Aquí puedes encontrar tu número de documento en tu cédula de identidad';

export const INFO_STORE_FORM =
  'Recuerda que hoy la devolución se hace por SVC, si tienes dudas consulta a tu gestor omnicanal.';

export const DNI_NOT_VALID =
  'La cédula de identidad no es válida. Revisa que no esté bloqueada o vencida.';

export const RECAPTCHA_NOT_VALID =
  'reCAPTCHA no está disponible actualmente. Por favor, inténtalo más tarde';

export const USER_NOT_VALID = 'Error al validar la identidad.';

export const DELIVERY_CREDIT_NOTE_RIPLEY_CARD = (
  <React.Fragment>
    La reversa se realizará en un plazo de <strong>1 a 4 días hábiles</strong>
    contados desde el día siguiente a tu solicitud de nota de crédito.
  </React.Fragment>
);

export const DELIVERY_CREDIT_NOTE_CREDIT_DEBIT_CARD = (
  <React.Fragment>
    La reversa se realizará en un plazo de <strong>1 a 5 días hábiles</strong>
    contados desde el día siguiente a tu solicitud de nota de crédito.
  </React.Fragment>
);

export const INFO_GO_MY_ACCOUNT_CHANGE_PASS = (
  <React.Fragment>
    Para tener una solución más rápida gestiona una autoatención desde {'"'}
    <strong>Mi Cuenta</strong>
    {'"'} en {'"'}
    <strong>Contraseña</strong>
    {'"'}.
  </React.Fragment>
);

export const INFO_GO_MY_ACCOUNT_CHANGE_EMAIL = (
  <React.Fragment>
    Para tener una solución más rápida gestiona una autoatención desde {'"'}
    <strong>Mi Cuenta</strong>
    {'"'} en {'"'}
    <strong>Perfil</strong>
    {'"'}.
  </React.Fragment>
);

export const INFO_GO_MY_ACCOUNT_INVOICE_COPY = (
  <React.Fragment>
    Para tener una solución más rápida gestiona una autoatención desde {'"'}
    <strong>Mi Cuenta</strong>
    {'"'} en {'"'}
    <strong>Realizar Solicitud</strong>
    {'"'}.
  </React.Fragment>
);

export const INFO_GO_MY_ACCOUNT_ASSEMBLE_PRODUCT = (
  <React.Fragment>
    Para tener una solución más rápida gestiona una autoatención desde {'"'}
    <strong>Mi Cuenta</strong>
    {'"'} en {'"'}
    <strong>Compras Realizadas</strong>
    {'"'}.
  </React.Fragment>
);

export const INFO_DISPATCH_GOLD_SILVER = (
  <React.Fragment>
    <b>Recuerda:</b>
    <ul>
      <li>
        Los <b>clientes Silver</b> tienen 1 despacho gratis al mes en ripley.com
        y App Ripley ingresando el código de descuento <b>DESPACHOSILVER</b>
        &nbsp; (tope de descuento $10.000 por despacho). Pagando con Tarjeta
        Crédito <u>Banco Ripley</u>
      </li>
      <br />
      <li>
        Los <b>clientes Gold</b> tienen 3 despachos gratis al mes en ripley.com
        y App Ripley ingresando el código de descuento <b>DESPACHOGOLD</b>&nbsp;
        (tope de descuento $10.000 por despacho). Pagando con Tarjeta Crédito{' '}
        <u>Banco Ripley</u>
      </li>
    </ul>
    Revisa las condiciones en nuestras{' '}
    <a href={legalRPGOBank} target="_blank" rel="noreferrer">
      Bases Promocionales
    </a>
    .
  </React.Fragment>
);

export const STATUS_CANCEL_PURCHASE = (
  <React.Fragment>
    Si compraste con <strong>Tarjeta Ripley</strong>, la reversa se realizará en
    un plazo de <strong>2 días hábiles</strong> contados desde el día siguiente
    a tu solicitud de nota de crédito.
    <br />
    <br />
    Si compraste con <strong>Tarjeta de Crédito o Débito</strong>, la reversa
    estará disponible entre <strong>3 a 5 días hábiles</strong> a partir del día
    siguiente a tu nota de crédito.
  </React.Fragment>
);

export const RPHONE_TEXTS = (
  <React.Fragment>
    <strong>
      Actualmente nuestros tiempos de respuesta son mayores a lo habitual por lo
      que te pedimos comprensión. En Ripley sabemos que necesitas soluciones
      rápidas a tus requerimientos, siempre estamos para ayudarte.
    </strong>
  </React.Fragment>
);

export const CANCEL_PURCHASE_CREDIT_NOTE = (
  <React.Fragment>
    El producto seleccionado está con <strong>Nota de Crédito</strong>, Una vez
    recepcionada la nota de crédito, los plazos de devolución puedes
    consultarlos{' '}
    <a
      style={{ textDecoration: 'none' }}
      href={`https://ripley.zendesk.com/hc/es-419/articles/4403906991511--Deseas-conocer-los-plazos-de-devolución-de-tu-dinero/`}
      target="blank"
    >
      aquí
    </a>
    .
  </React.Fragment>
);

export const messageFormNoteReverse = (
  <React.Fragment>
    <strong>Estamos procesando tu solicitud de anulación de compra.</strong>
    <br />
    Una vez que recibas la nota de crédito, puedes
    <br />
    <a
      style={{ textDecoration: 'none' }}
      href={ripleyReturnPeriods}
      target="blank"
    >
      revisar los plazos de devolución.
    </a>
  </React.Fragment>
);

export const messageFormNotDoneReverse = (
  <React.Fragment>
    <strong>
      ¿Se cumplió el plazo y aún no has recibido la devolución de tu dinero?
    </strong>
    <br />
    Rellena este formulario y envía tu solicitud para revisar tu caso
  </React.Fragment>
);

export const messageFormNotDoneReverseRipleyCard = (
  <React.Fragment>
    Contáctanos llamando al <strong>227 689 200</strong> o desde
    <br /> teléfono fijo al <strong>800 203 220</strong> y te atenderemos para
    <br /> resolver tu caso
  </React.Fragment>
);

export const REVIEW_FRECUENT_QUESTIONS = (
  <React.Fragment>
    Si necesitas ayuda rápida, revisa nuestras{' '}
    <a
      style={{ textDecoration: 'none' }}
      href={frecuentQuestions}
      target="blank"
    >
      <strong>Preguntas frecuentes</strong>
    </a>
    <br />
    <br />
  </React.Fragment>
);

export const TITLE_TICKET = (request) =>
  `${request ? 'Solicitud enviada' : 'Reporte enviado'} con éxito`;

export const TICKET_REVIEW = (request) => (
  <React.Fragment>
    Nuestras ejecutivas y ejecutivos estarán trabajando para revisar tu <br />
    solicitud y brindarte una pronta solución, te recordamos que el <br />
    horario de atención de nuestro Contact Center es <br />
    de <u>Lunes a Sábado de 08:00 a 18:00 hrs</u>.<br />
    <br />
    {request
      ? 'Tu solicitud quedará guardada'
      : 'Tu reporte quedará guardado'}{' '}
    en <strong>“Mi cuenta”</strong>, para que la puedas revisar cuando quieras
    en <strong>“Solicitudes de atención”</strong>
  </React.Fragment>
);

export const REDIRECT_FORM = (form) =>
  `En los próximos segundos serás redirigido al formulario de ${form}`;

export const CREDIT_NOTE_REVERSE_STATUS = (
  <React.Fragment>
    Para conocer el estado de la reversa de tu nota de crédito ingresa{' '}
    <a
      style={{ textDecoration: 'none' }}
      href={`${ripleyBank}/centro-de-ayuda`}
      target="blank"
    >
      aquí
    </a>
    ; también puedes llamar al <strong>800 20 32 20</strong> o desde celular al{' '}
    <strong>227689200</strong>.
  </React.Fragment>
);

export const INFO_FORGOTTEN_PASSWORD = (
  <React.Fragment>
    Antes de enviar una solicitud, te recomendamos revisar nuestro proceso de
    auto atención para recuperar contraseña. Puedes acceder directamente
    haciendo click{' '}
    <a
      style={{ textDecoration: 'none' }}
      href={forgottenPassword}
      target="blank"
    >
      aquí
    </a>
    .
  </React.Fragment>
);

export const WHATSAPP_LINE_CONTACT = (
  <React.Fragment>
    ¿Necesitas ayuda?{' '}
    <a href={whatsAppLineContact} target="_blank" rel="noopener noreferrer">
      Comunícate con nosotros por WhatsApp
    </a>{' '}
    y te ayudaremos a gestionar tu solicitud.
  </React.Fragment>
);
